// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"731e9a56","262":"0f1a7271","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};